import { Outlet, useOutletContext } from 'react-router-dom'

import { TrainingsSession } from 'generated/resources/graphql'

const EmployeeNextSessionCertificates = () => {
  const { employeeId, employeeAccessId, session } = useOutletContext<{
    employeeId: number
    employeeAccessId: number
    session: TrainingsSession
  }>()
  return <Outlet context={{ employeeId, employeeAccessId, session }} />
}

export default EmployeeNextSessionCertificates
